export const isAuthenticated = (state) => {
    // if (state.auth.auth.idToken) return true;
    // return false;
    let some = JSON.parse(window.localStorage.getItem("userDetails"));
    if (some != null) {
        return true;
    } else {
        return false;
    }
};